import generated from "./catalogue.generated.json";
import type { CatalogueItem, Category } from "../types";

export const CATALOGUE_VERSION = generated.version;
export const CATEGORIES = generated.categories as Category[];
export const CATALOGUE = generated.items as CatalogueItem[];

export const CATALOGUE_BY_ID = new Map(
  CATALOGUE.map((item) => [item.id, item] as const),
);
